<template>
  <main class="d-flex justify-content-center align-items-center vh-100 w-100 bg-gradient-secondary">
    <section class="p-5">
      <h3 class="mb-5 fw-bold">Bienvenue</h3>
      <form>
        <div class="mb-5">
          <label for="email" class="mb-3">Adresse mail</label>
          <input class="form-control" :class="invalid && email == '' ? 'invalid-field' : ''" type="email" name="email" placeholder="Entrez votre adresse-mail" id="email" v-model="email"/>
        </div>
        <div class="mb-5">
          <label for="pwd" class="mb-3">Mot de passe</label>
          <div class="input-group">
            <input class="form-control w-75" :class="invalid && password == '' ? 'invalid-field' : ''" :type="showPwd ? 'text' : 'password'" name="pwd" placeholder="Entrez votre mot de passe" id="pwd" v-model="password"/>
            <button class="form-control w-auto" type="button" @click="showPwd = !showPwd">
              <font-awesome-icon :icon="['far', 'eye']" v-if="showPwd" />
              <font-awesome-icon :icon="['far', 'eye-slash']" v-else />
            </button>
          </div>
        </div>
        <div class="mb-3">
          <input class="form-control bg-primary text-white" type="button" value="Connexion" @click="submitLogin"/>
        </div>
      </form>
      <p :style="{visibility: invalidCredentials ? 'visible' : 'hidden'}" class="text-danger mb-3">L'identifiant ou le mot de passe est incorrect<br>Le compte est peut-être désactivé</p>
      <p class="text-center w-100 p-0 m-0 fw-light text-secondary">© SNS SOLUTIONS 2024</p>
    </section>
  </main>
</template>

<script>
import store from '@/store'
export default {
  name: 'LoginPage',
  components: {

  },
  props: {

  },
  watch: {

  },
  data () {
    return {
      showPwd: false,
      email: '',
      password: '',
      invalid: false,
      invalidCredentials: false,
      dataStore: store
    }
  },
  methods: {
    submitLogin () {
      this.invalid = false
      if(this.email == '' || this.password == '') {
        this.invalid = true
        return
      }
      this.sendLoginRequest()
    },
    sendLoginRequest () {
      this.invalidCredentials = false
      const body = this.$genFD({
        LoginUser: this.email,
        PwdUser: this.password
      })
      fetch(this.$baseUrl+'/api/login', {
        method: "post",
        body
      })
      .then(res => {
        if(res.status != 200) {
          this.invalidCredentials = true
          throw new Error()
        }
        else {
          return res.json()
        }
      })
      .then(data => {
        // console.log(data)
        localStorage.setItem('userData', JSON.stringify(data))
        this.dataStore.api.apiUser = data.apiUser
        this.dataStore.api.apiPassword = data.apiPassword
        this.dataStore.api.host3cx = data.host3cx
        this.dataStore.api.apiAiActive = data.apiAiActive
        this.dataStore.api.apiRecordings = data.apiRecordings
        this.dataStore.api.api3cx = data.api3cx
        this.dataStore.api.api3cxUrl = data.api3cxUrl
        this.$emit('logged')
        // this.invalidCredentials = true // toggle if creds are wrong
      })
      .catch(err => {
        console.warn(err)
      })
    }
  },
  mounted () {
    // checks if already logged in. Or do this in nav guard ?
    if(localStorage.getItem('userData')) {
      let json = JSON.parse(localStorage.getItem('userData'))
      if(json.LoginUser && json.apiUser && json.apiPassword && json.idUser) {
        const body = this.$genFD({
          LoginUser: json.LoginUser,
          idUser: json.idUser
        })
        fetch(this.$baseUrl+'/api/login/'+json.idUser, {
          method: "post",
          headers: {
            authorization: 'Basic '+btoa(`${json.apiUser}:${json.apiPassword}`)
          },
          body
        })
        .then(res => {
          if(res.status != 200) {
            this.invalidCredentials = true
            throw new Error()
          }
          else {
            return res.json()
          }
        })
        .then(data => {
          // console.log(data)
          localStorage.setItem('userData', JSON.stringify(data))
          this.dataStore.api.apiUser = json.apiUser
          this.dataStore.api.apiPassword = json.apiPassword
          this.dataStore.api.host3cx = json.host3cx
          this.dataStore.api.apiAiActive = json.apiAiActive
          this.dataStore.api.apiRecordings = json.apiRecordings
          this.dataStore.api.api3cx = json.api3cx
          this.dataStore.api.api3cxUrl = json.api3cxUrl
          this.$emit('logged')
        })
        .catch(err => {
          console.warn(err)
        })
      }
    }
  }
}
</script>

<style scoped>
main {
  text-align: left;
}
section {
  width: 30%;
  min-width: 300px;
  height: auto;
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 1px 1px 10px 5px rgb(214, 214, 214); */
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
}
.invalid-field {
  border-color: rgba(240, 58, 58, 0.874);
}
.bg-gradient-primary{background-color:#089fe3;background-image:linear-gradient(180deg,#089fe3 10%,#36b9cc);background-size:cover;}
.bg-gradient-secondary{background-color:#858796;background-image:linear-gradient(180deg,#858796 10%,#60616f);background-size:cover;}
.bg-gradient-success{background-color:#1cc88a;background-image:linear-gradient(180deg,#1cc88a 10%,#13855c);background-size:cover;}
.bg-gradient-info{background-color:#36b9cc;background-image:linear-gradient(180deg,#36b9cc 10%,#258391);background-size:cover;}
.bg-gradient-warning{background-color:#f6c23e;background-image:linear-gradient(180deg,#f6c23e 10%,#dda20a);background-size:cover;}
.bg-gradient-danger{background-color:#e74a3b;background-image:linear-gradient(180deg,#e74a3b 10%,#be2617);background-size:cover;}
.bg-gradient-light{background-color:#f8f9fc;background-image:linear-gradient(180deg,#f8f9fc 10%,#c2cbe5);background-size:cover;}
.bg-gradient-dark{background-color:#5a5c69;background-image:linear-gradient(180deg,#5a5c69 10%,#373840);background-size:cover;}

</style>
